import { render } from "./reset-password.vue?vue&type=template&id=eebdb22e&scoped=true"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"

import "./reset-password.vue?vue&type=style&index=0&id=eebdb22e&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eebdb22e"],['__file',"src/components/reset-password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eebdb22e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eebdb22e', __exports__)) {
    api.reload('eebdb22e', __exports__)
  }
  
  module.hot.accept("./reset-password.vue?vue&type=template&id=eebdb22e&scoped=true", () => {
    api.rerender('eebdb22e', render)
  })

}


export default __exports__